/* eslint-disable @typescript-eslint/no-explicit-any */
import MuiTextField from "@mui/material/TextField";
import { inputStyles } from "./TextField.styles";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { InputAdornment } from "@mui/material";
import IconButton from "../IconButton/IconButton";
import { TextFieldType } from "../DynamicForm/DynamicForm";

interface TextFieldProps {
  disabled?: boolean;
  placeholder?: string;
  label?: string;
  field?: any;
  hasError?: boolean;
  setTextFieldValue?: Dispatch<SetStateAction<string>>;
  textFieldValue?: string;
  focused?: boolean;
  helperText?: string;
  type?: TextFieldType;
  multiline?: boolean;
  id?: string;
  flexGrow?: number;
}

function TextField(props: TextFieldProps) {
  const {
    disabled,
    placeholder,
    label,
    field,
    hasError,
    focused,
    helperText,
    type = "text",
    multiline = false,
    id,
    flexGrow,
  } = props;
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (!field || field.value === undefined || field.value === "") {
      setShowPassword(false);
    }
  }, [field]);

  return (
    <MuiTextField
      {...field}
      id={id}
      size="small"
      variant="outlined"
      placeholder={placeholder}
      sx={{
        ...inputStyles,
        flexGrow: flexGrow,
        width: flexGrow ? "0" : "100%",
      }}
      disabled={disabled}
      autoComplete="off"
      label={label}
      error={hasError}
      focused={focused}
      type={
        type === "text-area"
          ? undefined
          : type === "password" && showPassword
            ? "text"
            : type
      }
      helperText={helperText}
      multiline={multiline}
      // MUI rejects `rows` together with `maxRows`: a text-area gets a fixed
      // height, anything else auto-grows.
      {...(type === "text-area" ? { rows: 5 } : { maxRows: 5, rows: 1 })}
      slotProps={{
        // A tall text-area with its label floating inside reads as placeholder
        // text; keep the label in the outline notch so the field looks ready.
        inputLabel: type === "text-area" ? { shrink: true } : undefined,
        input: {
          endAdornment:
            type === "password" && field.value ? (
              <InputAdornment position="end">
                <IconButton
                  onClick={toggleShowPassword}
                  iconName={
                    !showPassword
                      ? "las la-eye icon-medium"
                      : "las la-eye-slash icon-medium"
                  }
                  color="primary"
                />
              </InputAdornment>
            ) : null,
        },
      }}
    />
  );
}

export default TextField;
